// hover:opacity-80 transition duration-150 ease-in-out
import { collapse } from "@growthops/ext-ts";
import React, { useMemo } from "react";
import { playAudio } from "../../utils/btnAudio";

const baseClass =
  "flex items-center justify-center rounded-full text-base font-semibold hover:animate-pulse  transition duration-150 ease-in-out";
const variantClasses = {
  primary: { container: `border-white `, base: `` },
  secondary: `bg-primary-blue text-white`,
  outlined: "border border-secondary-purple-100 text-secondary-purple-100",
  secondaryLight:
    "bg-primary-blue-600 text-primary-gray-1500 hover:bg-secondary-purple-100 hover:text-white  !transition !ease-in-out !duration-500",
  purple: "bg-secondary-purple-100 text-white",
  red: "bg-secondary-red-100 text-white",
  gradient_v1: "bg-sky-50 bg-custom-gradient !rounded-none !border-none",
  white: "bg-white text-purple-100",
  orange: "!bg-orange-200 !text-black !font-normal",
  red: "!bg-pink-1000 !text-white !font-normal",
  blue: "!bg-[#12B4FF] !text-black !font-normal",
  skin: "!bg-[#FFEFD2] !text-black !font-normal",
  transparent: "!bg-transparent !text-black !font-normal",

  //   outlined: "w-full h-[52px]  rounded-[100px] border border-primary-red ",
  //   outlinedColor: `w-full h-[52px] rounded-[100px] ${GRADIENT_SECONDARY} `,
  //   icon: `p-2.5 rounded-full ${GRADIENT_SECONDARY}`,
  // outlined: "border border-true-gray-300 text-true-gray-700",
};

const sizeClasses = {
  large: "px-8 py-5 heading-four space-x-4",
  regular: "px-6 py-3.5 heading-six space-x-3", //54
  middle: "px-8 py-[11.5px] heading-six space-x-3", //48px
  medium: "px-6 py-[9px] heading-six space-x-3", //44px
  small: "px-4 py-[6px] text-small space-x-2 ",
};

const useClasses = (variant, size, className) =>
  useMemo(
    () => ({
      root: collapse([
        baseClass,
        variantClasses[variant],
        sizeClasses[size],
        className ?? "",
      ]),
    }),
    [variant, className]
  );

const CButton = ({
  variant = "red",
  size = "regular",
  className,
  label,
  children,
  icon,
  disabled,
  onClick = () => { },
  ...intrinsicButtonProps
}) => {
  const classes = useClasses(variant, size, className);

  return (
    <button
      disabled={disabled}
      className={`${classes.root}`}
      onClick={(e) => {
        playAudio();
        onClick(e);
      }}
      {...intrinsicButtonProps}
    >
      {label} {children && children}
    </button>
  );
};

export default CButton;
